const JUP = ({ ...props }) => (
  <svg
    width="208"
    height="208"
    viewBox="0 0 208 208"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_3015_16622)">
      <path
        d="M104 208C161.438 208 208 161.438 208 104C208 46.5624 161.438 0 104 0C46.5624 0 0 46.5624 0 104C0 161.438 46.5624 208 104 208Z"
        fill="#0F1524"
      />
      <mask
        id="mask0_3015_16622"
        maskUnits="userSpaceOnUse"
        x="20"
        y="20"
        width="168"
        height="168"
      >
        <path
          d="M187.197 20.7998H20.7969V187.2H187.197V20.7998Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3015_16622)">
        <path
          d="M36.3828 150.222C43.1998 159.704 51.9441 167.638 62.0424 173.504C72.1409 179.369 83.3648 183.034 94.979 184.258C89.0038 175.266 80.3182 166.994 69.4752 160.696C58.6322 154.398 47.1492 150.958 36.3828 150.222Z"
          fill="url(#paint0_linear_3015_16622)"
        />
        <path
          d="M84.0459 135.618C63.156 123.482 40.5455 120.389 24.3672 125.853C25.929 131.015 27.9888 136.013 30.5175 140.777C44.5738 140.451 59.9208 144.268 74.2012 152.563C88.4818 160.857 99.4042 172.304 106.087 184.679C111.481 184.514 116.846 183.826 122.108 182.627C118.837 165.87 104.931 147.758 84.0459 135.618Z"
          fill="url(#paint1_linear_3015_16622)"
        />
        <path
          d="M183.593 86.3561C180.938 75.5527 176.131 65.3954 169.462 56.4906C162.794 47.5857 154.399 40.1159 144.78 34.5273C135.161 28.9387 124.513 25.3458 113.475 23.9632C102.436 22.5806 91.2318 23.4367 80.5312 26.4802C98.4077 28.6679 118.25 35.3788 137.71 46.684C157.17 57.9892 172.843 71.9005 183.593 86.3561Z"
          fill="url(#paint2_linear_3015_16622)"
        />
        <path
          d="M157.586 125.977C148.436 110.78 132.761 96.2289 113.451 85.0115C94.1415 73.7936 73.7409 67.3862 56.0229 66.9623C40.4352 66.5931 28.7363 71.1245 23.9342 79.3917C23.9068 79.4407 23.8685 79.487 23.8384 79.5364C23.4064 81.087 23.0345 82.64 22.6953 84.1992C29.4008 81.5519 37.17 80.078 45.8089 79.9136C65.02 79.5531 86.5199 85.6977 106.361 97.2243C126.201 108.751 142.201 124.39 151.4 141.253C155.525 148.849 158.098 156.329 159.118 163.475C160.304 162.414 161.469 161.317 162.599 160.177C162.629 160.125 162.649 160.07 162.678 160.016C167.48 151.74 165.623 139.335 157.586 125.977Z"
          fill="url(#paint3_linear_3015_16622)"
        />
        <path
          d="M98.7572 110.295C69.1871 93.1163 36.5103 90.4252 20.7969 102.414C20.8278 106.166 21.1146 109.912 21.6556 113.626C26.278 112.225 31.0419 111.342 35.8595 110.996C53.4189 109.674 72.7777 114.567 90.3455 124.778C107.912 134.99 121.761 149.391 129.315 165.287C131.403 169.643 132.995 174.218 134.062 178.928C137.557 177.558 140.954 175.952 144.232 174.123C146.863 154.531 128.336 127.478 98.7572 110.295Z"
          fill="url(#paint4_linear_3015_16622)"
        />
        <path
          d="M172.796 100.542C163.542 85.3616 147.73 70.7692 128.283 59.4777C108.837 48.1863 88.3571 41.6776 70.5819 41.1553C57.0315 40.7643 46.5359 44.0486 41.0938 50.2536C63.6905 46.425 93.4958 52.8598 122.384 69.6425C151.275 86.4255 171.637 109.134 179.496 130.659C182.19 122.862 179.846 112.118 172.796 100.542Z"
          fill="url(#paint5_linear_3015_16622)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3015_16622"
        x1="129.21"
        y1="56.0969"
        x2="54.4141"
        y2="184.679"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0001" stop-color="#C7F284" />
        <stop offset="1" stop-color="#00BEF0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3015_16622"
        x1="129.211"
        y1="56.097"
        x2="54.415"
        y2="184.679"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0001" stop-color="#C7F284" />
        <stop offset="1" stop-color="#00BEF0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3015_16622"
        x1="129.209"
        y1="56.097"
        x2="54.4134"
        y2="184.679"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0001" stop-color="#C7F284" />
        <stop offset="1" stop-color="#00BEF0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3015_16622"
        x1="129.213"
        y1="56.0972"
        x2="54.4163"
        y2="184.679"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0001" stop-color="#C7F284" />
        <stop offset="1" stop-color="#00BEF0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3015_16622"
        x1="129.209"
        y1="56.0969"
        x2="54.413"
        y2="184.679"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0001" stop-color="#C7F284" />
        <stop offset="1" stop-color="#00BEF0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3015_16622"
        x1="129.212"
        y1="56.0973"
        x2="54.4163"
        y2="184.679"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0001" stop-color="#C7F284" />
        <stop offset="1" stop-color="#00BEF0" />
      </linearGradient>
      <clipPath id="clip0_3015_16622">
        <rect width="208" height="208" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default JUP;
